package world.phantasmal.web.questEditor.models

data class WaveModel(val id: Int, val areaId: Int, val sectionId: Int)
